import { render, staticRenderFns } from "./pages-side-bar.vue?vue&type=template&id=de21987e&"
import script from "./pages-side-bar.vue?vue&type=script&lang=js&"
export * from "./pages-side-bar.vue?vue&type=script&lang=js&"
import style0 from "./pages-side-bar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de21987e')) {
      api.createRecord('de21987e', component.options)
    } else {
      api.reload('de21987e', component.options)
    }
    module.hot.accept("./pages-side-bar.vue?vue&type=template&id=de21987e&", function () {
      api.rerender('de21987e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/info-pages/pages-side-bar.vue"
export default component.exports